import { isPage, logosURL } from './utils/helpers.js';
import initRodeoWidgets from './rodeoSubpage/index.js';

export function themeController(themeData) {
  // HEADER LOGO URL
  logosURL(themeData);

  if (isPage('gnfa-rodeo')) {
    initRodeoWidgets();
  }

  setTimeout(() => {
    $('body').addClass('loaded');
  }, 500);
}
